import * as types from '../types';

import * as Commons from '../utils/Commons';
import * as Constants from '../utils/Constants';
import * as ServerOperations from '../utils/ServerOperations';
import { STRINGS } from '../utils/Strings';

const loaderHandler = require('../components/react-native-busy-indicator/LoaderHandler');

export const resetState = () => ({
    type: types.SETTINGS_RESET_STATE
});

export const updateState = payload => ({
    type: types.SETTINGS_UPDATE_STATE,
    payload
});

export const toggleRecNewsInfo = value => async dispatch => {
    loaderHandler.showLoader(STRINGS.loading, self);
    const username = (await Commons.getUserObject()).USERNAME;
    const response = await ServerOperations.toggleRecNewsInfo(username, value);
    if (response != null) {
        dispatch(updateState({ recNewsInfo: value }));
        Commons.saveToAS(Constants.recNewsInfo, value ? Constants.TRUE_STR : Constants.FALSE_STR);
    } else {
        Commons.okMsgAlert(STRINGS.offline);
    }
    loaderHandler.hideLoader();
};
